import NotificationsHistoryPage from "components/pages/NotificationsHistoryPage";

export default function CaptureNotifiHistory(props) {
    return <NotificationsHistoryPage />
}